import ActionCreators from './src/actions/creators'
import ActionTypes from './src/actions/types'
import alarms from './src/reducers/alarms'
import backupAlarms from './src/reducers/backupAlarms'
import incidentAlarms from './src/reducers/incidentAlarms'
import groups from './src/reducers/groups'
import contacts from './src/reducers/contacts'
import pendingActions from './src/reducers/pendingActions'
import userInfo from './src/reducers/userInfo'
import progress from './src/reducers/progress'
import userSettings from './src/reducers/userSettings'
import conversations from './src/reducers/conversations'
import calendarEvents from './src/reducers/calendarEvents'
import pendingConversationMessages from './src/reducers/pendingConversationMessages'
import connections from './src/reducers/connections'
import alarmActions from './src/reducers/alarmActions'
import StringUtils from './src/utils/StringUtils'
import AlarmUtils from './src/utils/AlarmUtils'
import CalendarUtilsWithExtras from './src/utils/CalendarUtilsWithExtras'
import AlarmUtilsWithExtras from './src/utils/AlarmUtilsWithExtras'
import * as AlarmUtilsExtended from './src/utils/AlarmUtils'
import DateTimeUtils from './src/utils/DateTimeUtils'
import * as Selectors from './src/store/selectors'
import Utils from './src/utils/Utils'
import NetworkUtils from './src/utils/NetworkUtils'
import GroupUtils from './src/utils/GroupUtils'
import TaskManager from './src/api/TaskManager'
import FirebaseManager from './src/api/FirebaseManager'
import FirestoreManager from './src/api/FirestoreManager'
import AbstractEditAlarmContainer from './src/components/AbstractEditAlarmContainer'
import WebUtils from './src/utils/WebUtils'
import AbstractAlarmCategoryActionsProvider from './src/components/AbstractAlarmCategoryActionsProvider'

const Reducers = {
  alarms,
  backupAlarms,
  incidentAlarms,
  groups,
  contacts,
  pendingActions,
  userInfo,
  progress,
  userSettings,
  conversations,
  pendingConversationMessages,
  connections,
  alarmActions,
  calendarEvents
}

export {
  ActionCreators,
  ActionTypes,
  Reducers,
  StringUtils,
  AlarmUtils,
  CalendarUtilsWithExtras,
  DateTimeUtils,
  AlarmUtilsExtended,
  Selectors,
  AlarmUtilsWithExtras,
  TaskManager,
  FirebaseManager,
  FirestoreManager,
  Utils,
  NetworkUtils,
  GroupUtils,
  AbstractEditAlarmContainer,
  WebUtils,
  AbstractAlarmCategoryActionsProvider
}
